import { apiHelper } from '@/utils/api.helper'

export const ORDER = {
  addToCart,
  getOrderList,
  getOrderDetail,
  orderReschedule,
  getOrderCancellationReason,
  cancelOrder,
  buyAgain,
  refundOrder,
  getMultipleOrderDetail
}

const URL = {
  ORDER: 'order',
  ADD_CART: 'addcart',
  INDEX: 'index',
  DETAILS: 'details',
  RESCHEDULE: 'reschedule',
  CANCEL_REASON: 'cancel_reason',
  CANCEL: 'cancel',
  BUY_AGAIN: 'buyagain',
  RETURN_REFUND: 'return_refund',
  MULTIPLE_DETAILS: 'multiple_details'
}

function addToCart(data) {
  const requestBody = {
    product: data
  }
  return apiHelper().post(`${URL.ORDER}/${URL.ADD_CART}`, null, {
    params: requestBody
  })
}

function getOrderList(id) {
  return apiHelper().get(`${URL.ORDER}/${URL.INDEX}?type=${id}`)
}

function getOrderDetail(poNumber) {
  return apiHelper().get(`${URL.ORDER}/${URL.DETAILS}?po_number=${poNumber}`)
}

function orderReschedule(form) {
  return apiHelper().put(`${URL.ORDER}/${URL.RESCHEDULE}`, null, {
    params: form
  })
}

function getOrderCancellationReason() {
  return apiHelper().get(`${URL.ORDER}/${URL.CANCEL_REASON}`)
}

function cancelOrder(form) {
  return apiHelper().put(`${URL.ORDER}/${URL.CANCEL}`, null, {
    params: form
  })
}

function buyAgain(data) {
  return apiHelper().post(`${URL.ORDER}/${URL.BUY_AGAIN}`, null, {
    params: data
  })
}

function refundOrder(data) {
  return apiHelper().post(`${URL.ORDER}/${URL.RETURN_REFUND}`, null, {
    params: data
  })
}

function getMultipleOrderDetail(poNumbers) {
  return apiHelper().get(`${URL.ORDER}/${URL.MULTIPLE_DETAILS}?po_numbers=${poNumbers}`)
}
